import axios from "axios";

export async function lookupAddress({ zipCode, houseNumber, addition }) {
  return new Promise((resolve, reject) => {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/api/address`, {
        postcode: zipCode,
        houseNumber: houseNumber,
        houseNumberAddition: !!addition ? addition : null,
      })
      .then((res) => {
        if (res.status === 200) resolve(res.data);
        else reject();
      })
      .catch((err) => {
        reject(err);
      });
  });
}
